import { ContactInfo } from '../../../interfaces/ContactInfo';
import { ContactInfoDto } from '../../../interfaces/dtos/ContactInfoDto';
import { SubsidiariesContactInfosDto } from '../../../interfaces/dtos/SubsidiariesContactInfosDto';
import { SubsidiaryContactInfosDto } from '../../../interfaces/dtos/SubsidiaryContactInfosDto';
import { SubsidiariesContactInfos } from '../../../interfaces/SubsidiariesContactInfos';
import { SubsidiaryContactInfos } from '../../../interfaces/SubsidiaryContactInfos';

export default function transformGetResponse(data: SubsidiariesContactInfosDto): SubsidiariesContactInfos {
  const transformContact = (contact: ContactInfoDto): ContactInfo => ({
    information: contact.information,
    display: contact.display,
    value: contact.value,
  });
  const transformSubsidiary = (subsidiary: SubsidiaryContactInfosDto): SubsidiaryContactInfos => ({
    title: subsidiary.title,
    phoneNumbers: subsidiary.phoneNumbers?.map(transformContact),
    emails: subsidiary.emails?.map(transformContact),
    urls: subsidiary.urls?.map(transformContact),
  });
  return {
    descripton: data?.descripton,
    subsidiaries: data?.subsidiaries?.map(transformSubsidiary),
  };
}
